import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicab() {



  const cardData = {
"keyword": "Pune to Mumbai Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Mumbai Cab service for business trips, airport transfers, family travel, weekend getaways, and one-way journeys. With professional drivers, well-maintained air-conditioned vehicles, and transparent pricing with no hidden charges, we ensure a smooth and stress-free travel experience. Our Pune to Mumbai taxi service is designed for punctual pickups, safe driving, and flexible travel options including one-way, round-trip, and customized packages. Choose from sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Shivai Travels provides a convenient and dependable intercity travel solution between Pune and Mumbai.",

"topPlaces": [
  {
    "title": "Gateway of India",
    "description":
      "Gateway of India is a historic monument located in South Mumbai and one of the most iconic landmarks in the city. Travelers using Pune to Mumbai cab service often visit this famous tourist spot for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description":
      "Marine Drive is a scenic coastal boulevard known for its sunset views and city skyline. A cab from Pune to Mumbai makes it easy to enjoy a relaxing drive along this beautiful promenade."
  },
  {
    "title": "Juhu Beach",
    "description":
      "Juhu Beach is one of Mumbai’s most popular beaches known for street food, sunset views, and vibrant atmosphere. Pune to Mumbai cab travelers often include this destination in their city tour."
  },
  {
    "title": "Siddhivinayak Temple",
    "description":
      "Siddhivinayak Temple is a famous religious site dedicated to Lord Ganesha and attracts devotees from across India. A comfortable cab ride from Pune ensures easy access to this spiritual landmark."
  },
  {
    "title": "Bandra Worli Sea Link",
    "description":
      "Bandra Worli Sea Link is an architectural marvel offering stunning sea and skyline views. Travelers enjoy a scenic drive across this bridge during their Pune to Mumbai journey."
  },
  {
    "title": "Haji Ali Dargah",
    "description":
      "Haji Ali Dargah is a famous mosque and tomb located on an islet in Mumbai. Visitors traveling by cab from Pune often visit this peaceful spiritual destination."
  },
  {
    "title": "Colaba Causeway",
    "description":
      "Colaba Causeway is a bustling shopping street in South Mumbai known for cafes, street shopping, and local culture. Pune to Mumbai cab service makes it easy to explore this vibrant area."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description":
      "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage railway station known for its Victorian Gothic architecture. Travelers often pass by this historic landmark during their Mumbai visit."
  },
  {
    "title": "Elephanta Caves",
    "description":
      "Elephanta Caves are ancient rock-cut temples located on Elephanta Island near Mumbai. Cab travelers from Pune can visit Gateway of India and take a ferry to explore this heritage site."
  },
  {
    "title": "Nariman Point",
    "description":
      "Nariman Point is a major business district in Mumbai offering beautiful sea views and corporate offices. Pune to Mumbai cab service is commonly used for business and office travel to this area."
  }
],



services: [
  {
    name: "Pune to Mumbai Cab",
    description: "Pune to Mumbai cab service provides reliable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys for business travelers, tourists, and families. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Mumbai Taxi",
    description: "Pune to Mumbai taxi service offers dependable transportation for passengers traveling between Pune and Mumbai via the Mumbai–Pune Expressway. Comfortable vehicles provide smooth highway travel with spacious seating and luggage capacity suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across both cities. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Mumbai",
    description: "Cab from Pune to Mumbai service provides comfortable intercity transportation for passengers traveling for business, tourism, airport transfers, and family visits. Vehicles ensure reliable expressway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Mumbai. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Mumbai",
    description: "Taxi from Pune to Mumbai service offers reliable transportation with comfortable vehicles and professional drivers for highway travel between the two cities. Vehicles provide spacious seating and smooth travel experience suitable for airport transfers, business travel, and tourism trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Mumbai Cab Service",
    description: "Pune to Mumbai cab service provides dependable transportation solutions for passengers traveling between Pune and Mumbai with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for expressway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for airport transfers, tourism, and business travel. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Mumbai Taxi Fare",
    description: "Pune to Mumbai taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Mumbai. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth expressway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Mumbai One Way Cab",
    description: "Pune to Mumbai one way cab service provides economical transportation for passengers traveling from Pune to Mumbai without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for airport transfers, business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Mumbai including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Mumbai Round Trip Taxi",
    description: "Pune to Mumbai round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Mumbai. Comfortable vehicles provide smooth expressway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for business travel, tourism, meetings, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Mumbai Cab Booking",
    description: "Pune to Mumbai cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Mumbai. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Mumbai Cab",
    description: "Cheap Pune to Mumbai cab service provides affordable transportation between Pune and Mumbai with comfortable vehicles and economical pricing. Vehicles ensure reliable expressway travel suitable for airport transfers, business trips, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Mumbai. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Mumbai Taxi",
    description: "Best Pune to Mumbai taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and airport transfers. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Mumbai Cab",
    description: "Sedan Pune to Mumbai cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Mumbai. Sedan vehicles provide smooth expressway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Mumbai. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Mumbai Taxi",
    description: "SUV Pune to Mumbai taxi service provides spacious transportation for families and groups traveling between Pune and Mumbai. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Mumbai Cab",
    description: "Innova Pune to Mumbai cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Mumbai. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Expressway Taxi Pune Mumbai",
    description: "Expressway taxi Pune Mumbai service offers reliable transportation via the Mumbai–Pune Expressway with comfortable vehicles and experienced drivers. Vehicles ensure smooth and safe highway travel suitable for airport transfers, business meetings, tourism, and family visits. Professional drivers ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow convenient expressway taxi reservations."
  },
  {
    name: "Pune to Mumbai Airport Cab",
    description: "Pune to Mumbai airport cab service provides dependable airport transportation between Pune and Mumbai Airport terminals. Comfortable vehicles offer spacious seating and luggage capacity suitable for airport journeys and long-distance travel. Professional drivers ensure punctual pickup and safe driving services via the Mumbai–Pune Expressway. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Mumbai. Flexible booking options allow convenient airport cab reservations."
  }
],

tableData: [
  ["Pune to Mumbai Cab", "Pune to Mumbai Taxi"],
  ["Cab from Pune to Mumbai", "Taxi from Pune to Mumbai"],
  ["Pune to Mumbai Cab Service", "Pune to Mumbai Taxi Fare"],
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai Round Trip Taxi"],
  ["Pune to Mumbai Cab Booking", "Cheap Pune to Mumbai Cab"],
  ["Best Pune to Mumbai Taxi", "Sedan Pune to Mumbai Cab"],
  ["SUV Pune to Mumbai Taxi", "Innova Pune to Mumbai Cab"],
  ["Expressway Taxi Pune Mumbai", "Pune to Mumbai Airport Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mumbai Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Mumbai cab service with professional drivers, comfortable vehicles, and timely pickup for smooth intercity travel between Pune and Mumbai."
      },
      {
        WhyChooseheading: "Affordable Pune to Mumbai Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Mumbai cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Pune to Mumbai Cab Availability",
        WhyChoosedescription: "Our Pune to Mumbai cab service operates 24 hours a day for airport transfers, business travel, family trips, emergency transportation, and late-night journeys."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide safe and comfortable travel experiences on the Mumbai Pune Expressway."
      },
      {
        WhyChooseheading: "One Way & Round Trip Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Mumbai cab service, round-trip bookings, Mumbai Airport transfers, and customized travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Expressway Drivers",
        WhyChoosedescription: "Our experienced drivers frequently operate on the Mumbai Pune Expressway and ensure safe driving, smooth highway travel, and punctual arrival for every Pune to Mumbai journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mumbai cab service?", answer: "Pune to Mumbai cab service provides comfortable taxi transportation between Pune and Mumbai for business, airport transfers, family trips, and outstation travel." },
    { question: "Is Pune to Mumbai cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Mumbai cab service." },
    { question: "Which vehicles are available for Pune to Mumbai travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Mumbai?", answer: "Yes, customers can book one-way as well as round-trip Pune to Mumbai cab services." },
    { question: "Do you provide Mumbai Airport drop service?", answer: "Yes, Shivai Travels provides Mumbai Airport pickup and drop services." },
    { question: "Are all Pune to Mumbai taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Mumbai cab service online?", answer: "Yes, customers can easily book Pune to Mumbai cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for families and group tours." },
    { question: "Are Pune to Mumbai cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Mumbai cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Deepak Jadhav",
      feedback:
        "Booked Pune to Mumbai cab service with Shivai Travels. Clean vehicle, professional driver, and very comfortable journey.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Rina Shah",
      feedback:
        "Excellent Pune to Mumbai taxi service. Affordable pricing, on-time pickup, and smooth expressway travel experience.",
      rating: 5
    }
  ];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cabs",
  "image": "https://shivaitravels.com/assets/images/pune-to-mumbai-cab.jpg",
  "description": "Book Pune to Mumbai cab service for comfortable one-way and round-trip travel. Shivai Travels offers affordable taxi service with sedan, SUV, Innova, and luxury cab options for Mumbai city and airport transfers via expressway with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-mumbai-cabs"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Cabs | Affordable One Way & Round Trip Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Mumbai cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs via expressway with reliable 24x7 service."
  />

  <meta
    name="keywords"
    content="Pune to mumbai cab, pune to mumbai taxi, cab from pune to mumbai, taxi from pune to mumbai, pune to mumbai cab service, pune to mumbai taxi fare, pune to mumbai one way cab, pune to mumbai round trip taxi, pune to mumbai cab booking, cheap pune to mumbai cab, best pune to mumbai taxi, sedan pune to mumbai cab, suv pune to mumbai taxi, innova pune to mumbai cab, expressway taxi pune mumbai, Pune to Mumbai Cabs, Pune to Mumbai Cab Service, Pune to Mumbai Taxi Service, Pune to Mumbai Cab Booking, Mumbai to Pune Cab Service, One Way Cab Pune to Mumbai, Pune to Mumbai Airport Cab, Cheap Pune to Mumbai Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicab;